import { useAuth } from "../../../lib/auth";

export default function SettingsTab() {
  const { user } = useAuth();
  return (
    <div data-testid="settings-tab">
      <h1 className="font-serif text-4xl mb-8">Réglages</h1>
      <div className="bg-[#FDFBF7] rounded-2xl border border-[#2D2A26]/10 p-8 max-w-2xl">
        <h3 className="font-serif text-2xl mb-4">Compte administrateur</h3>
        <div className="space-y-3">
          <div className="flex justify-between border-b border-[#2D2A26]/10 py-2"><span className="overline">Email</span><span>{user?.email}</span></div>
          <div className="flex justify-between border-b border-[#2D2A26]/10 py-2"><span className="overline">Rôle</span><span>{user?.role}</span></div>
          <div className="flex justify-between py-2"><span className="overline">Nom</span><span>{user?.name}</span></div>
        </div>
        <p className="text-sm text-[#4A3F35]/70 mt-6">Pour modifier le mot de passe, mettez à jour <code className="bg-[#F6F3EC] px-1.5 py-0.5 rounded">ADMIN_PASSWORD</code> dans <code className="bg-[#F6F3EC] px-1.5 py-0.5 rounded">/app/backend/.env</code> puis redémarrez le backend.</p>
      </div>
    </div>
  );
}
